export function calculateDurationSince(startDate, endDate) {
	const MONTH_NAMES = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];
	console.log("Date: ");

	if (startDate === undefined || endDate === undefined) {
		return "Invalid date";
	}

	const startMonth = startDate.split(" ")[0];
	const startYear = startDate.split(" ")[1];

	let endMonth, endYear;

	if (endDate === "Present") {
		const currentDate = new Date();
		endMonth = MONTH_NAMES[currentDate.getMonth()];
		endYear = currentDate.getFullYear();
	} else {
		endMonth = endDate.split(" ")[0];
		endYear = endDate.split(" ")[1];
	}

	console.log("Start month", startMonth, " Start Year", startYear);
	console.log("End month", endMonth, " End Year", endYear);

	if (startYear === endYear) {
		const monthDiff =
			MONTH_NAMES.indexOf(endMonth) - MONTH_NAMES.indexOf(startMonth);
		return monthDiff === 1 ? `${monthDiff} month` : `${monthDiff} months`;
	} else {
		let yearDiff = endYear - startYear;
		const monthDiff =
			MONTH_NAMES.indexOf(endMonth) - MONTH_NAMES.indexOf(startMonth) + 1;
		console.log(monthDiff, yearDiff);
		if (monthDiff < 0) {
			yearDiff -= 1;
			if (yearDiff === 0) {
				return `${12 + monthDiff} months`;
			} else {
				if (11 + monthDiff === 0) {
					return `${yearDiff} yr`;
				}
				return `${yearDiff} yr ${11 + monthDiff} months`;
			}
		} else {
			if (yearDiff === 0) {
				return `${monthDiff} months`;
			} else {
				if (monthDiff === 0) {
					return `${yearDiff} yr`;
				}
				return `${yearDiff} yr ${monthDiff} months`;
			}
		}
	}
}
